import React, { useEffect } from "react";
import InputBox from "../../components/input/InputBox";
import Button from "../../components/button/Button";
import {
  MyLoginWrapper,
  ImageSection,
  MyText,
  LogoImg,
  MyIcon,
  IconWrapper,
  Section,
  LoginBgPreview,
  ErrorDiv,
  ErrorText,
  LoginRoot,
} from "./Login.styles";
import Logo from "../../assets/images/logo.png";
import BgImg from "../../assets/images/bg-pic.png";
import BgBlurImg from "../../assets/images/bg-pic-blur.jpg";
import EyeOpen from "../../assets/icons/eye.svg";
import EyeHide from "../../assets/icons/hide.png";
import { loginAction } from "../../services/login.service";
import { useAuth } from "../../contexts/AuthContext";
import { Navigate } from "react-router-dom";
import ProgressiveImage from "../../components/progressiveImage/ProgressiveImage";

const Login: React.FC<{}> = () => {
  const [login, setLogin] = React.useState({
    username: "",
    password: "",
    hide: true,
  });
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState({
    username: "",
    password: "",
  });

  const [apiError, setApiError] = React.useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const { name, value } = e.target;
    setLogin((prev) => ({ ...prev, [name]: value }));
    setError((prev) => ({ ...prev, [name]: "" }));
  };

  const checkError = () => {
    let hasError = false;
    if (login?.username === "" && login?.password === "") {
      hasError = true;
      setError({
        username: "Username can't be blank.",
        password: "Please enter your password.",
      });
    } else if (login?.username === "") {
      hasError = true;
      setError((prev) => ({
        ...prev,
        username: "Username can't be blank.",
      }));
    } else if (login?.password === "") {
      hasError = true;
      setError((prev) => ({
        ...prev,
        password: "Please enter your password.",
      }));
    }
    return hasError;
  };

  const handlePasswordType = () => {
    const { hide } = login;
    setLogin((prev) => ({ ...prev, hide: !hide }));
  };

  const eyeIcon = () => (
    <IconWrapper
      error={Boolean(error?.password)}
      onClick={handlePasswordType}
      id="div-btn"
    >
      <MyIcon id="icon-img" src={login.hide ? EyeOpen : EyeHide} alt="view" />
    </IconWrapper>
  );

  const auth = useAuth();

  useEffect(() => {
    if (apiError)
      setTimeout(() => {
        setApiError("");
      }, 5000);
  }, [apiError]);

  if (auth?.user?.accessToken)
    return <Navigate to="tmrw-admin/clinic-details" replace={true} />;

  return (
    <LoginRoot>
      <ImageSection>
        {/* <img src={BgImg} alt="bg-image" className="w-100 h-100 fit-cover" /> */}
        <ProgressiveImage
          placeHolderSrc={BgBlurImg}
          src={BgImg}
          alt="bg-image"
          imageComponent={LoginBgPreview}
        />
      </ImageSection>
      <LogoImg src={Logo} alt="LOGO" />
      <Section>
        <MyLoginWrapper className="border-1">
          <div>
            <MyText>Sign In</MyText>
          </div>
          {apiError && (
            <ErrorDiv>
              <ErrorText>{apiError}</ErrorText>
            </ErrorDiv>
          )}
          <div
            style={{
              position: "relative",
              maxWidth: "320px",
            }}
          >
            <InputBox
              id="username"
              labelName="Username"
              placeHolderName="Username"
              value={login?.username}
              handler={handleChange}
              type="text"
              error={error.username}
            />
            <InputBox
              id="password"
              labelName="Password"
              placeHolderName="Type Password"
              value={login?.password}
              handler={handleChange}
              type={login.hide ? "password" : "text"}
              error={error.password}
            />
            {eyeIcon()}
          </div>
          <div>
            <Button
              text={loading ? "Please wait..." : "Log In"}
              disabled={loading}
              onClick={() => {
                let hasError = checkError();
                setApiError("");
                !hasError &&
                  loginAction(
                    {
                      username: login.username.trim(),
                      password: login.password,
                    },
                    setApiError,
                    auth?.login,
                    setLoading
                  );
              }}
            />
          </div>
        </MyLoginWrapper>
      </Section>
    </LoginRoot>
  );
};

export default Login;
